import { ENV } from '$env';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerProvider } from './server';
import { ViewProvider } from './view';

@Injectable()
export class DenunciaProvider {

  constructor(private serverProvider: ServerProvider, private viewProvider: ViewProvider) {
  }

  public loadItems(): Observable<Array<any>> {
    let body = {
      operacao: 'DENUNCIA_LISTAR'
    };

    return Observable.create((observer) => {
      this.serverProvider.postData(body).subscribe(
        (data) => {
          if (data && data.denuncias) {
            observer.next(data.denuncias);
          } else {
            observer.next([]);
          }
          observer.complete();
        },
        (error) => { observer.error(error); }
      );
    });
  }

  public addItem(denuncia, captcha): Observable<any> {
    const operacao = (ENV.web)
      ? 'DENUNCIA_ADICIONAR_WEB'
      : 'DENUNCIA_ADICIONAR';

    let body = {
      operacao: operacao,
      denuncia: denuncia,
      captcha: captcha
    };

    return Observable.create((observer) => {
      this.serverProvider.postData(body).subscribe(
        (data) => {
          if (!data) {
            this.viewProvider.showError('Ocorreu um problema ao registrar sua denúncia.');
            observer.complete();
            return;
          }

          observer.next(data);
          observer.complete();
        },
        (error) => { observer.error(error); }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/denuncia.ts